// extracted by mini-css-extract-plugin
export default {"text":"styles__text--YqNdS","header-1":"styles__header-1--Vx70f","header-2":"styles__header-2--d-cG0","header-3":"styles__header-3--5YwXA","compact":"styles__compact--mmR1I"};